<template>
  <v-app class="bcgrnd">
    <v-container fluid grid-list-md text-xs-center style="background-color:#f4f4f4 ;padding: 0;" >
      <v-card flat style="background-color:#f4f4f4" >
    <v-card-title style="padding:0px">
      <h5>Overview</h5>
      <v-spacer></v-spacer>


      <v-icon small color="green" style="font-size: xx-large;" @click="onChat()" class="mr-1">chat</v-icon>  <!-- @click="onChat(props.item)" -->
    <v-btn @click.stop="logOutDialog = true" round flat style="text-transform: unset !important ;background-color: #ffffff; ">
                        <!-- <avatar :size="32" :username="loggedInUserName"></avatar> -->
                        <v-icon color="warning" style="font-size:30px;">person</v-icon>

                       &nbsp;&nbsp;{{loggedInUserName}}
      <!-- <v-icon>arrow_drop_down</v-icon> -->

    </v-btn>

          <v-dialog v-model="logOutDialog" max-width="290" persistent>
            <v-card style="padding: 20px !important ; border-radius: 0px;border:1px solid;background-color:orange">
              <v-sheet color="transparent" style="text-align:center">
                <v-icon color="#0d47a1" :size="40">https</v-icon>
              </v-sheet>
              
              <h3 style="text-align:center;font-size:20px;color:red">Logout</h3>

   <v-card-text style="text-align:center;color:black">Are you sure you want to logout from Worldwin ?</v-card-text>

              
                <v-btn style="padding-left:60px" dark color="green" flat @click="logOutDialog = false">No</v-btn>&nbsp;&nbsp;
                <v-btn dark color="red" flat @click="logOut()">Yes</v-btn>
            </v-card>
          </v-dialog>
    </v-card-title>
  </v-card>
    </v-container>
  

    <v-container  >
    <v-layout row wrap class="my-2 mx-2" >


      <!-- <v-flex xs12 sm12 md3 >

        <template>
          <v-card
            class="mx-auto my-3 das-card  "
            width="250" 
            style="color: #06CACA;   border:solid 2px #06CACA;"
          >
          <v-icon color="#06CACA">how_to_reg</v-icon>

            <template >
              Registration         
            </template>

          </v-card>
        </template>
        </v-flex> -->
        <v-flex xs12 sm12 md3>

      <template>
        <v-card
        to="/studentTrainingProcess"
          class="mx-auto my-3 das-card"
          width="250"
          style="color: #AC19BA;   border:solid 2px #AC19BA;"
        >
        <v-icon color="#AC19BA">school</v-icon>

          <template>
            Training Process       
          </template>

        </v-card>
      </template>
      </v-flex>
      <v-flex xs12 sm12 md3>

<template>
  <v-card
    class="mx-auto my-3 das-card"
    width="250"
    style="color: #0E9A57;   border:solid 2px #0E9A57;"
    v-if="applicationShow==true"
    to="/studentApplicationProcess"
  >
  <v-icon color="#0E9A57">description</v-icon>

    <template>
      Application Process
        </template>

  </v-card>
</template>
      </v-flex>

      <v-flex xs12 sm12 md3 >

<template>
  <v-card
    class="mx-auto my-3 das-card  "
    width="250" 
    style="color: #06CACA;   border:solid 2px #06CACA;"
  >
  <v-icon color="#06CACA">how_to_reg</v-icon>

    <template >
      <span style="font-size: 13px;">University Admission</span>         
    </template>

  </v-card>
</template>
</v-flex>

      <v-flex xs12 sm12 md3>

<template>
  <v-card
    class="mx-auto my-3 das-card"
    width="250"
    style="color: #D9255B;   border:solid 2px #D9255B;"

  >
  
  <v-icon color="#D9255B">public</v-icon>

    <template>
      Visa Process    </template>

  </v-card>
</template>
</v-flex>
<v-flex xs12 sm12 md3>

<template>
  <v-card
    class="mx-auto my-3 das-card"
    width="250"
    style="color: #D63224;   border:solid 2px #D63224;"

  >
  <v-icon color="#D63224">account_balance</v-icon>

    <template>
      University Reg
      </template>

  </v-card>
</template>
</v-flex>
<v-flex xs12 sm12 md4>


</v-flex>
    </v-layout>
  </v-container>

  <!-- ============================= Chat Dialog ============================= -->

  <v-dialog
      v-model="chatDialog"
      width="550"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Worldwin
        </v-card-title>

        <v-card-text>
          <div class="scroll">
            <div v-for="item in messages" :key="item.id">
            <span v-if="item.sendBy=='Counsellor'" style="background-color: #F99420;padding: 5px;border-radius: 5px;font-size: 12px;">
              {{ item.message }}
            </span><br/>
            <span v-if="item.sendBy=='Counsellor'" style="font-size: 10px;color: grey;">{{ item.date }}</span>

            <div style="text-align: right;">
              <span v-if="item.sendBy=='Student'" style="background-color: #f00e0e;color:whitesmoke;padding: 5px;border-radius: 5px;font-size: 12px;">
              {{ item.message }}
              </span><br/>
              <span v-if="item.sendBy=='Student'" style="font-size: 10px;color: grey;">{{ item.date }}</span>
            </div>
          </div>
          </div>
          
        </v-card-text>
       
        <v-card-actions>
          <v-form ref="chatForm" v-model="valid" lazy-validation>
            <v-text-field
                style="width: 450px;"
                v-model="chatForm.message"
                :rules="emptyRule"
                required
                placeholder="Message"
              ></v-text-field>
          </v-form>
          <div style="text-align: right;padding-left: 5px;">
            <v-icon style="cursor:pointer;text-align: center;color: rgb(3, 65, 3);" color="white;" @click="onSend()">send</v-icon>
          </div>
          <!-- <div class="flex-grow-1"></div>
          <v-spacer></v-spacer>
       <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
          >
            Save
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>

//import Vue from "vue";
import config from "../../config.json";
import config1 from "../../config1.json";
export default {
  components: {
  },
  data() {
    return {
      roleType: sessionStorage.roles,
      loggedInUserName: sessionStorage.loggedInUserName,
      logOutDialog: false,
      customerNo: 0,
      productNo: 0,
      presentOrderList: [],
      presentOrder: 0,
      presentOrderAmount: 0,
      deliveredOrderAmount: 0,
      deliveredOrder: 0,
      applicationShow: false,

      chatDialog: false,
      chatForm: {
        message: null
      },
      messages: [],
      student: null,

      emptyRule: [v => !!v || "Input is required"],

      search: "",
      tableHeader: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Order Code", value: "orderCode" },
        { text: "Order Date", value: "date" },
        { text: "Customer Name", value: "fullName" },
        { text: "Mobile Number", value: "mobileNumber" },
        { text: "Total Amount", value: "totalPrice" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" }
      ]
    };
  },

  methods: {
    getData() {
      let id = sessionStorage.getItem("loggedInUserID");
      let userType = sessionStorage.getItem("roles");
      if(userType=="Student") {
        this.axios
      .get(config1.API + 'Admin/' + id, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let studentId = res.data.studentId;

        this.axios
        .get(config1.API + "Leads/" + studentId, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.applicationShow = res.data.applicationShow;
          console.log(res);
          this.profilePic = res.data.profileSrc;
          this.showPic = res.data.showPic;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.$Progress.fail();
        });
      });
      }
    },

    onEdit(item) {
      this.$router.push(`/viewSalesOrder/${item.id}`);
    },

    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },

    onMessage() {
      this.axios
        .get(config1.API + "Chats/1", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.messages = res.data;
          console.log(this.messages);
        })
        .catch(() => {
          this.$Progress.fail();
        });
    },

    onChat() {
      this.chatDialog=true;
      this.onMessage();
    },

    onSend() {
    if (this.$refs.chatForm.validate()) {
      this.axios
          .post(
            config1.API + "Chats",
            {
              message: this.chatForm.message
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$refs.chatForm.reset();
            this.onMessage();
          })
          .catch(() => {
            this.$toaster.error("Try again later");
          });
    }
    else {
      this.$toaster.error("Write some message");
    }
    },
  },

  created() {
    this.getData();
  }
};
</script>

<style scoped>
.bcgrnd {
  background-color: white !important;
  background-size: cover;
}
.v-card {
  padding: 25px;
  letter-spacing: 0.5px;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
.txt_dec:hover {
    text-decoration: none !important;
}
.flashing_effect {
  background-color: green !important;
  /* background-image: linear-gradient(-90deg, #f44336, #280071); */
  /* padding: 12px 15px; */
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes flashing{
  0% {
     opacity: 1.0;
  }
  25% {
     opacity: 0.6;
  }
  50% {
     opacity: 0.3;
  }
  75% {
     opacity: 0.6;
  }
  100% {
     opacity: 1.0;
  }
}
marquee {
  height: 85%;
}
.hvr:hover {
  cursor: pointer;
  color: #3486D7;
  text-decoration: underline;
}
.das-card i{
   font-size: 30px;
   margin-right: 8px;
}
.das-card {
  cursor: pointer;

}
div.scroll { 
                width: auto; 
                height: 350px; 
                overflow-x: hidden; 
                overflow-x: auto; 
                text-align:justify; 
            }

</style>
